import { FaAngleLeft } from "react-icons/fa6";
import { MdMail } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import { Accordion, EmailBox, IntegrationBenefits } from "./components";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
// import { getDataFromDb, updateDataInDb } from "../../../../helper";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { get } from "firebase/database";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../../../services/mongod.data";

const Email = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [install, setInstall] = useState(false);
  const location = useLocation();
  const [addEmailBox, setAddEmailBox] = useState(false);
  const [integrationData, setIntegrationData] = useState(null);
  const [loading, setLoading] = useState(false);

  const queryParams = new URLSearchParams(location.hash);
  const accessToken = queryParams.get("#access_token");

  const CF_Mailbox_api = `https://us-central1-causalfunnel-21.cloudfunctions.net/CF_Mailbox_server`;

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      setLoading(true);
      try {
        // let api_url = `${user}/graph-integration/`;
        // let result = await getDataFromDb(api_url);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.mailbox || apiData.data.data.mailbox;

        if (result) {
          setInstall(true);
          setIntegrationData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  useEffect(() => {
    const fetchProfileData = async () => {
      setLoading(true);
      try {
        const body = JSON.stringify({ access_token: accessToken });
        const response = await fetch(CF_Mailbox_api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
        });
        const data = await response.json();

        const profileData = {
          accessToken: accessToken,
          email: data?.emailAddresses[0].value,
          data: data,
        };
        // let apiUrl = `${user}/graph-integration/mailbox`;
        // let emailData = await getDataFromDb(apiUrl);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let emailData = apiData.data.mailbox || apiData.data.data.mailbox;

        let integrationEmails = emailData?.emails || [];
        let checkEmail = integrationEmails.find(
          (e) => e.email === profileData.email
        );
        if (checkEmail) {
          let newIntegrationData = integrationEmails.map((e) =>
            e.email === profileData.email ? profileData : e
          );
          // await updateDataInDb(apiUrl, {
          await updateDataInMongoDb(user, "graph-integration", ["mailbox", "emails", ], newIntegrationData);
          setIntegrationData({ emails: newIntegrationData });
        } else {
          integrationEmails.push(profileData);
          await updateDataInMongoDb(user, "graph-integration", ["mailbox", "emails", ], integrationEmails);
          setIntegrationData({ emails: integrationEmails });
        }
        setInstall(true);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (accessToken) {
      fetchProfileData();
    }
  }, [accessToken]);

  const handleDelete = async (email) => {
    setLoading(true);
    // let apiUrl = `${user}/graph-integration/mailbox`;
    let newEmails = integrationData?.emails.filter((e) => e.email !== email);
    try {
      await updateDataInMongoDb(user, "graph-integration", ["mailbox", "emails", ], newEmails);
      if (newEmails?.length === 0) setInstall(false);
      setIntegrationData({ ...integrationData, emails: newEmails });
    } catch (error) {
      console.error("Error deleting email:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingAnimation />;

  return (
    <div className="bg-gray-200 w-full p-3">
      {addEmailBox ? (
        <EmailBox
          setAddEmailBox={setAddEmailBox}
        />
      ) : (
        <></>
      )}
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>

      {install ? (
        <Accordion
          integrationData={integrationData}
          setIntegrationData={setIntegrationData}
          setAddEmailBox={setAddEmailBox}
          handleDelete={handleDelete}
        />
      ) : (
        <div className="bg-white p-4 rounded-md my-3">
          <header className="flex justify-between items-center border-bottom">
            <div className="my-3 flex items-center gap-3">
              <MdMail className="text-3xl text-gray-500" />
              <p className="text-lg font-semibold">Mailbox</p>
            </div>
          </header>
          <IntegrationBenefits
            addEmailBox={addEmailBox}
            setAddEmailBox={setAddEmailBox}
          />
        </div>
      )}
    </div>
  );
};

export default Email;
